import { Component, inject, OnInit } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { TableLazyLoadEvent, TableModule } from 'primeng/table'
import { TabViewModule } from 'primeng/tabview'
import { TagModule } from 'primeng/tag'
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownModule } from 'primeng/dropdown'
import { DialogModule } from 'primeng/dialog'
import { WebhookService } from '../../services/webhook.service'
import {
  WebhookEventDetailModel,
  WebhookEventModel,
  WebhookEventStatus,
} from '../../../../core/models/webhook-event.model'

@Component({
  selector: 'app-webhooks',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    TabViewModule,
    TagModule,
    CardModule,
    ButtonModule,
    TooltipModule,
    InputTextModule,
    DropdownModule,
    DialogModule,
    DatePipe,
  ],
  templateUrl: './webhooks.component.html',
  styleUrl: './webhooks.component.scss',
})
export class WebhooksComponent implements OnInit {
  private webhookService = inject(WebhookService)

  public webhooks$ = this.webhookService.webhooks$
  public total$ = this.webhookService.total$
  public loading$ = this.webhookService.loading$
  public selectedWebhook$ = this.webhookService.selectedWebhook$
  public detailLoading$ = this.webhookService.detailLoading$

  public detailVisible = false
  public filterProvider = ''
  public filterStatus = ''
  public filterSearch = ''

  private currentPage = 1
  private currentPerPage = 15

  public statusOptions = [
    { label: 'Tous les statuts', value: '' },
    { label: 'Reçu', value: 'received' },
    { label: 'Traité', value: 'processed' },
    { label: 'Échoué', value: 'failed' },
  ]

  ngOnInit() {
    this.loadWebhooks()
  }

  loadWebhooks() {
    this.webhookService
      .getWebhooks(
        this.currentPage,
        this.currentPerPage,
        this.filterProvider || undefined,
        this.filterStatus || undefined,
        this.filterSearch || undefined
      )
      .subscribe()
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.currentPage =
      event.first !== undefined && event.rows
        ? Math.floor(event.first / event.rows) + 1
        : 1
    this.currentPerPage = event.rows ?? 15
    this.loadWebhooks()
  }

  onFilter() {
    this.currentPage = 1
    this.loadWebhooks()
  }

  openDetail(event: WebhookEventModel) {
    this.detailVisible = true
    this.webhookService.getWebhook(event.id).subscribe()
  }

  closeDetail() {
    this.detailVisible = false
    this.webhookService.clearSelected()
  }

  getStatusSeverity(
    status: WebhookEventStatus
  ): 'success' | 'warn' | 'danger' | 'info' {
    switch (status) {
      case 'processed':
        return 'success'
      case 'failed':
        return 'danger'
      case 'received':
        return 'info'
    }
  }

  getStatusLabel(status: WebhookEventStatus): string {
    switch (status) {
      case 'processed':
        return 'Traité'
      case 'failed':
        return 'Échoué'
      case 'received':
        return 'Reçu'
    }
  }

  formatJson(value: unknown): string {
    if (value === null || value === undefined) return ''
    return JSON.stringify(value, null, 2)
  }
}
